import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import React from "react";
import { SnackbarProvider } from "notistack";
import SnackbarCloseButton from "splash_components/SnackbarCloseButton/SnackbarCloseButton";
import GymSignupSuccess from "splash_components/GymSignupSucccess/GymSignupSuccess";

export default function GymSignupSuccessRoot() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#004080",
      },
      secondary: {
        main: "#FFFFFF",
      },
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4500}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
    >
      <ThemeProvider theme={theme}>
        <GymSignupSuccess />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
